export function buildClassName(
  baseClassName: string,
  modifierClassName: string,
  isModifierActive: boolean
): string {
  if (isModifierActive) {
    return `${baseClassName} ${modifierClassName}`;
  }
  return baseClassName;
}
